/**
 * Professional Loader Component
 * Single, unified loading indicator for the entire AFF Portal application
 * Designed to match the application's professional aesthetic
 */

import React from 'react';
import './ProfessionalLoader.css';

const ProfessionalLoader = ({ 
  size = 'medium', 
  message = 'Loading...', 
  inline = false,
  overlay = false,
  className = '',
  variant = 'default' // default, minimal, card
}) => {
  const getSizeClass = () => {
    switch (size) {
      case 'small': return 'loader-small';
      case 'large': return 'loader-large';
      case 'xlarge': return 'loader-xlarge';
      default: return 'loader-medium';
    }
  };

  const getVariantClass = () => {
    switch (variant) {
      case 'minimal': return 'loader-minimal';
      case 'card': return 'loader-card';
      default: return 'loader-default';
    }
  };

  const containerClass = `
    professional-loader 
    ${getSizeClass()} 
    ${getVariantClass()}
    ${inline ? 'loader-inline' : ''} 
    ${overlay ? 'loader-overlay' : ''} 
    ${className}
  `.trim();

  if (overlay) {
    return (
      <div className="loader-overlay-backdrop">
        <div className={containerClass}>
          <div className="loader-content">
            <div className="loader-spinner">
              <div className="spinner-ring"></div>
              <div className="spinner-ring"></div>
              <div className="spinner-ring"></div>
            </div>
            {message && <div className="loader-message">{message}</div>}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={containerClass}>
      <div className="loader-content">
        <div className="loader-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        {message && <div className="loader-message">{message}</div>}
      </div>
    </div>
  );
};

export default ProfessionalLoader;
